var SORT_TYPE;
(function (SORT_TYPE) {
    SORT_TYPE["SORT_BY_UNSPECIFIED"] = "SORT_BY_UNSPECIFIED";
    SORT_TYPE["SORT_BY_PUBLISH_AT"] = "SORT_BY_PUBLISH_AT";
    SORT_TYPE["SORT_BY_PRICE"] = "SORT_BY_PRICE";
    SORT_TYPE["SORT_BY_MOST_VIEW"] = "SORT_BY_MOST_VIEW";
    SORT_TYPE["SORT_BY_TOP_SALE_QUANTITY"] = "SORT_BY_TOP_SALE_QUANTITY";
    SORT_TYPE["SORT_BY_DISCOUNT_PERCENT"] = "SORT_BY_DISCOUNT_PERCENT";
    SORT_TYPE["SORT_BY_MOST_VIEW_3_DAYS"] = "SORT_BY_MOST_VIEW_3_DAYS";
    SORT_TYPE["SORT_BY_MOST_VIEW_7_DAYS"] = "SORT_BY_MOST_VIEW_7_DAYS";
    SORT_TYPE["SORT_BY_MOST_VIEW_30_DAYS"] = "SORT_BY_MOST_VIEW_30_DAYS";
    SORT_TYPE["SORT_BY_MOST_VIEW_90_DAYS"] = "SORT_BY_MOST_VIEW_90_DAYS";
    SORT_TYPE["SORT_BY_TOP_SALE_QUANTITY_3_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_3_DAYS";
    SORT_TYPE["SORT_BY_TOP_SALE_QUANTITY_7_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_7_DAYS";
    SORT_TYPE["SORT_BY_TOP_SALE_QUANTITY_30_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_30_DAYS";
    SORT_TYPE["SORT_BY_TOP_SALE_QUANTITY_90_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_90_DAYS";
})(SORT_TYPE || (SORT_TYPE = {}));
var SORT_ORDER;
(function (SORT_ORDER) {
    SORT_ORDER["ORDER_BY_UNSPECIFIED"] = "ORDER_BY_UNSPECIFIED";
    SORT_ORDER["ORDER_BY_ASCENDING"] = "ORDER_BY_ASCENDING";
    SORT_ORDER["ORDER_BY_DESCENDING"] = "ORDER_BY_DESCENDING";
})(SORT_ORDER || (SORT_ORDER = {}));

export { SORT_ORDER, SORT_TYPE };
